import { DialogTitle } from '@aibees/shared/components';
import { usePlanDetailContext } from '@aibees/shared/features/price-and-plan/components/plan-detail/context';
import { classnames } from '@aibees/shared/utils';
import { DialogContent, Grid } from '@mui/material';
import { memo } from 'react';
import { DialogLeftSide } from './components/dialog-left-side';
import { DialogRightSide } from './components/dialog-right-side';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreditCalculatorProps as Props } from './types';

export const CreditCalculator = memo(({ className, open, onClose }: Props) => {
  const { reset } = usePlanDetailContext();

  const handleClose = () => {
    onClose();
    reset();
  };

  return (
    <Styled.Wrapper
      className={classnames('CreditCalculator', className)}
      sx={SX.root}
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        title="Calculate the amount of AI Ark credits you’ll need each month"
        icon="calculator"
        onClose={handleClose}
      />
      <DialogContent>
        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={6}>
            <DialogLeftSide />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DialogRightSide />
          </Grid>
        </Grid>
      </DialogContent>
    </Styled.Wrapper>
  );
});

CreditCalculator.displayName = 'CreditCalculator';
